export default __webpack_public_path__ + "static/3-a63f1db0412b5240d5cd5ef22912fc11.jpeg";